export enum RequestHeaders {
  /** Set to 'true' to suppress the loading indicator for a request */
  SUPPRESS_LOADING = 'uxo-suppress-loading'
}
